/*
  Cosmoshop custom behaviour layer
  --------------------------------
  Store-specific JavaScript lives here instead of inline in Liquid sections.
*/
(function() {
  'use strict';

  var BRAND_BREAKPOINT = 750;
  var CONTRAST_THRESHOLD = 0.55;

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function debounce(callback, delay) {
    var timer;
    return function() {
      var args = arguments;
      window.clearTimeout(timer);
      timer = window.setTimeout(function() {
        callback.apply(null, args);
      }, delay);
    };
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  /* Shop By Brands menu -------------------------------------------------- */
  function initBrandMenu() {
    var boxes = document.querySelectorAll('.header-menu nav.category_box, .header-category nav.category_box, nav#CategoryBox.category_box');
    if (!boxes.length) return;

    function closeBox(categoryBox) {
      var siteCat = categoryBox.querySelector('#header-SiteCat');
      var sideCategories = categoryBox.querySelector('.side-categories');
      if (!siteCat || !siteCat.classList.contains('is-open')) return;

      window.clearTimeout(categoryBox._cosmoshopBrandCloseTimer);
      siteCat.classList.add('is-closing');
      if (sideCategories) {
        sideCategories.classList.remove('active');
        sideCategories.setAttribute('aria-expanded', 'false');
      }

      categoryBox._cosmoshopBrandCloseTimer = window.setTimeout(function() {
        siteCat.classList.remove('is-open', 'is-closing');
      }, 190);
    }

    function closeOtherBoxes(currentBox) {
      boxes.forEach(function(categoryBox) {
        if (categoryBox !== currentBox) closeBox(categoryBox);
      });
    }

    function initBox(categoryBox) {
      var siteCat = categoryBox.querySelector('#header-SiteCat');
      var sideCategories = categoryBox.querySelector('.side-categories');
      if (!siteCat || !sideCategories) return;

      function setBrandMenuRows() {
        var rows = Math.ceil(siteCat.children.length / 2);
        siteCat.style.setProperty('--cosmoshop-brand-rows', rows || 1);
      }

      function openBrandMenu() {
        window.clearTimeout(categoryBox._cosmoshopBrandCloseTimer);
        closeOtherBoxes(categoryBox);
        setBrandMenuRows();
        siteCat.classList.remove('is-closing');
        siteCat.classList.add('is-open');
        sideCategories.classList.add('active');
        sideCategories.setAttribute('aria-expanded', 'true');
      }

      function closeBrandMenu() {
        closeBox(categoryBox);
      }

      function resetMobileToggles() {
        categoryBox.querySelectorAll('.mobile_togglemenu').forEach(function(toggle) {
          toggle.remove();
        });
        categoryBox.querySelectorAll('.toggle, .active').forEach(function(item) {
          if (item !== sideCategories) item.classList.remove('toggle', 'active');
        });
        categoryBox.querySelectorAll('.site-nav__childlist-drop, .header-nav__childlist').forEach(function(menu) {
          menu.removeAttribute('style');
        });
      }

      function addToggle(items, selectorToToggle) {
        items.forEach(function(item) {
          var toggle = item.querySelector(':scope > .mobile_togglemenu');
          if (!toggle) {
            toggle = document.createElement('span');
            toggle.className = 'mobile_togglemenu';
            toggle.setAttribute('aria-hidden', 'true');
            item.appendChild(toggle);
          }
          item.classList.add('toggle');
          if (toggle.dataset.cosmoshopMobileReady === 'true') return;
          toggle.dataset.cosmoshopMobileReady = 'true';
          toggle.addEventListener('click', function(event) {
            event.preventDefault();
            event.stopPropagation();
            var target = item.querySelector(':scope > ' + selectorToToggle);
            item.classList.toggle('active');
            if (target) {
              var isOpen = item.classList.contains('active');
              target.style.display = isOpen ? 'block' : 'none';
            }
          });
        });
      }

      function setupMobileToggles() {
        resetMobileToggles();
        if (window.innerWidth >= BRAND_BREAKPOINT) return;

        addToggle(
          Array.prototype.slice.call(categoryBox.querySelectorAll('ul#header-SiteCat > li.site-cat--has-dropdown')),
          '.site-nav__childlist-drop'
        );
        addToggle(
          Array.prototype.slice.call(categoryBox.querySelectorAll('ul#header-SiteCat li.site-cat--has-dropdown .site-nav__childlist-item-dropdown')),
          '.header-nav__childlist'
        );
        addToggle(
          Array.prototype.slice.call(categoryBox.querySelectorAll('ul#header-SiteCat > li.hiden_menu_site')),
          '.site-cat__dropdown'
        );
      }

      categoryBox._cosmoshopSetupMobileToggles = setupMobileToggles;

      siteCat.classList.remove('is-open', 'is-closing');
      siteCat.removeAttribute('style');
      sideCategories.setAttribute('role', 'button');
      sideCategories.setAttribute('tabindex', '0');
      sideCategories.setAttribute('aria-expanded', 'false');
      sideCategories.setAttribute('aria-haspopup', 'true');

      if (categoryBox.dataset.cosmoshopBrandReady !== 'true') {
        categoryBox.dataset.cosmoshopBrandReady = 'true';

        sideCategories.addEventListener('click', function(event) {
          event.preventDefault();
          event.stopPropagation();
          if (siteCat.classList.contains('is-open')) {
            closeBrandMenu();
          } else {
            openBrandMenu();
          }
        }, true);

        sideCategories.addEventListener('keydown', function(event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          if (siteCat.classList.contains('is-open')) {
            closeBrandMenu();
          } else {
            openBrandMenu();
          }
        });
      }

      setupMobileToggles();
    }

    boxes.forEach(initBox);

    if (document.documentElement.dataset.cosmoshopBrandDocumentReady !== 'true') {
      document.documentElement.dataset.cosmoshopBrandDocumentReady = 'true';
      document.addEventListener('click', function(event) {
        document.querySelectorAll('.header-menu nav.category_box, .header-category nav.category_box, nav#CategoryBox.category_box').forEach(function(categoryBox) {
          if (!categoryBox.contains(event.target)) closeBox(categoryBox);
        });
      });
      document.addEventListener('keydown', function(event) {
        if (event.key !== 'Escape') return;
        document.querySelectorAll('.header-menu nav.category_box, .header-category nav.category_box, nav#CategoryBox.category_box').forEach(closeBox);
      });
      window.addEventListener('resize', debounce(function() {
        document.querySelectorAll('.header-menu nav.category_box, .header-category nav.category_box, nav#CategoryBox.category_box').forEach(function(categoryBox) {
          var siteCat = categoryBox.querySelector('#header-SiteCat');
          if (siteCat) siteCat.style.setProperty('--cosmoshop-brand-rows', Math.ceil(siteCat.children.length / 2) || 1);
          if (typeof categoryBox._cosmoshopSetupMobileToggles === 'function') {
            categoryBox._cosmoshopSetupMobileToggles();
          } else {
            initBox(categoryBox);
          }
        });
      }, 150), { passive: true });
    }
  }

  /* Collection sort dropdown ------------------------------------------- */
  function closeSortDropdowns(exceptWidget) {
    document.querySelectorAll('[data-collection-sort].is-open').forEach(function(widget) {
      if (widget === exceptWidget) return;
      widget.classList.remove('is-open');
      var button = widget.querySelector('.collection-sort-custom__button');
      if (button) button.setAttribute('aria-expanded', 'false');
    });
  }

  function toggleSortDropdown(widget) {
    if (!widget) return;
    var willOpen = !widget.classList.contains('is-open');
    closeSortDropdowns(widget);
    widget.classList.toggle('is-open', willOpen);
    var button = widget.querySelector('.collection-sort-custom__button');
    if (button) button.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
  }

  function initCollectionSort() {
    if (document.documentElement.dataset.cosmoshopCollectionSortReady === 'true') return;
    document.documentElement.dataset.cosmoshopCollectionSortReady = 'true';

    document.addEventListener('click', function(event) {
      var toggleButton = event.target.closest('.collection-sort-custom__button');
      if (toggleButton) {
        event.preventDefault();
        toggleSortDropdown(toggleButton.closest('[data-collection-sort]'));
        return;
      }

      var optionButton = event.target.closest('.collection-sort-custom__option');
      if (optionButton) {
        event.preventDefault();

        var widget = optionButton.closest('[data-collection-sort]');
        var form = optionButton.closest('form');
        var select = form ? form.querySelector('select[name="sort_by"]') : null;
        var valueLabel = widget ? widget.querySelector('.collection-sort-custom__value') : null;
        var selectedValue = optionButton.getAttribute('data-sort-value');

        if (select && selectedValue) select.value = selectedValue;
        if (valueLabel) valueLabel.textContent = optionButton.textContent.trim();

        if (widget) {
          widget.querySelectorAll('.collection-sort-custom__option').forEach(function(button) {
            var isSelected = button === optionButton;
            button.classList.toggle('is-selected', isSelected);
            button.setAttribute('aria-selected', isSelected ? 'true' : 'false');
          });
          closeSortDropdowns();
        }

        if (form) {
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            form.submit();
          }
        }
        return;
      }

      if (!event.target.closest('[data-collection-sort]')) closeSortDropdowns();
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') closeSortDropdowns();
    });
  }

  /* Slideshow ------------------------------------------------------------ */
  function whenImageReady(img, callback) {
    if (!img) return;
    if (img.complete && img.naturalWidth && img.naturalHeight) {
      callback();
    } else {
      img.addEventListener('load', callback, { once: true });
    }
  }

  function reserveImageAspectRatios(slider) {
    slider.querySelectorAll('img').forEach(function(img) {
      whenImageReady(img, function() {
        if (img.naturalWidth && img.naturalHeight) {
          img.style.aspectRatio = img.naturalWidth + ' / ' + img.naturalHeight;
        }
      });
    });
  }

  function getActiveSlideImage(slider) {
    return slider.querySelector('.slides > li.flex-active-slide img') ||
      slider.querySelector('.slides > li:not(.clone) img') ||
      slider.querySelector('.slides img');
  }

  function getScaledCanvas(img) {
    var naturalWidth = img.naturalWidth;
    var naturalHeight = img.naturalHeight;
    if (!naturalWidth || !naturalHeight) return null;

    var canvasWidth = 260;
    var canvasHeight = Math.max(1, Math.round((naturalHeight / naturalWidth) * canvasWidth));
    var cacheKey = canvasWidth + 'x' + canvasHeight + ':' + img.currentSrc;

    if (img._cosmoContrastCache && img._cosmoContrastCache.key === cacheKey) {
      return img._cosmoContrastCache;
    }

    var canvas = document.createElement('canvas');
    canvas.width = canvasWidth;
    canvas.height = canvasHeight;
    var ctx = canvas.getContext('2d', { willReadFrequently: true });
    if (!ctx) return null;

    try {
      ctx.drawImage(img, 0, 0, canvasWidth, canvasHeight);
    } catch (error) {
      return null;
    }

    img._cosmoContrastCache = { key: cacheKey, canvas: canvas, ctx: ctx };
    return img._cosmoContrastCache;
  }

  function getAverageLuminance(img, button) {
    var imageRect = img.getBoundingClientRect();
    var buttonRect = button.getBoundingClientRect();
    var scaled = getScaledCanvas(img);
    if (!scaled || !imageRect.width || !imageRect.height) return null;

    var relativeX = ((buttonRect.left + (buttonRect.width / 2)) - imageRect.left) / imageRect.width;
    var relativeY = ((buttonRect.top + (buttonRect.height / 2)) - imageRect.top) / imageRect.height;
    var x = clamp(Math.round(relativeX * scaled.canvas.width), 0, scaled.canvas.width - 1);
    var y = clamp(Math.round(relativeY * scaled.canvas.height), 0, scaled.canvas.height - 1);
    var radius = 10;
    var sx = clamp(x - radius, 0, scaled.canvas.width - 1);
    var sy = clamp(y - radius, 0, scaled.canvas.height - 1);
    var sw = clamp((radius * 2) + 1, 1, scaled.canvas.width - sx);
    var sh = clamp((radius * 2) + 1, 1, scaled.canvas.height - sy);

    try {
      var data = scaled.ctx.getImageData(sx, sy, sw, sh).data;
      var r = 0;
      var g = 0;
      var b = 0;
      var count = 0;

      for (var i = 0; i < data.length; i += 4) {
        var alpha = data[i + 3];
        if (alpha < 10) continue;
        r += data[i];
        g += data[i + 1];
        b += data[i + 2];
        count += 1;
      }

      if (!count) return null;
      r = r / count;
      g = g / count;
      b = b / count;

      return ((0.2126 * r) + (0.7152 * g) + (0.0722 * b)) / 255;
    } catch (error) {
      return null;
    }
  }

  function setArrowContrast(slider, img, selector, colorVar, shadowVar) {
    var button = slider.querySelector(selector);
    if (!button) return false;

    var luminance = getAverageLuminance(img, button);
    if (luminance === null) return false;

    var useWhite = luminance < CONTRAST_THRESHOLD;
    slider.style.setProperty(colorVar, useWhite ? '#ffffff' : '#000000');
    slider.style.setProperty(shadowVar, useWhite ? 'rgba(0, 0, 0, 0.55)' : 'rgba(255, 255, 255, 0.7)');
    return true;
  }

  function initSlideshow(slider) {
    if (!slider || slider.dataset.cosmoshopSlideshowReady === 'true') return;
    slider.dataset.cosmoshopSlideshowReady = 'true';

    reserveImageAspectRatios(slider);

    function updateArrowContrast() {
      var img = getActiveSlideImage(slider);
      if (!img) return;

      whenImageReady(img, function() {
        var previousUpdated = setArrowContrast(slider, img, '.flex-direction-nav .flex-prev', '--slider-prev-arrow-color', '--slider-prev-arrow-shadow');
        var nextUpdated = setArrowContrast(slider, img, '.flex-direction-nav .flex-next', '--slider-next-arrow-color', '--slider-next-arrow-shadow');

        if (previousUpdated || nextUpdated) {
          slider.dataset.arrowContrastReady = 'true';
        }
      });
    }

    function moveSlider(direction) {
      if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.flexslider) return;
      window.jQuery(slider).flexslider(direction);
      window.setTimeout(updateArrowContrast, 80);
      window.setTimeout(scheduleSliderLayoutRefresh, 700);
    }

    function refreshSliderLayout() {
      if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.flexslider) return;

      var $slider = window.jQuery(slider);
      var flexslider = $slider.data('flexslider');
      if (!flexslider || flexslider.animating || !flexslider.viewport || !flexslider.newSlides) return;

      var viewportWidth = Math.round(window.jQuery(flexslider.viewport).width() || slider.clientWidth || 0);
      if (!viewportWidth) return;

      flexslider.w = viewportWidth;
      flexslider.itemW = viewportWidth;
      flexslider.itemM = flexslider.vars ? flexslider.vars.itemMargin : 0;
      flexslider.boxPadding = 0;
      flexslider.computedW = viewportWidth;
      flexslider.computedM = flexslider.itemM || 0;

      flexslider.newSlides.css({
        width: flexslider.computedW,
        marginRight: flexslider.computedM,
        float: 'left',
        display: 'block'
      });

      if (typeof flexslider.setProps === 'function') {
        flexslider.setProps(flexslider.computedW, 'setTotal');
      }

      if (flexslider.vars && flexslider.vars.smoothHeight && flexslider.viewport && flexslider.slides) {
        window.jQuery(flexslider.viewport).height(flexslider.slides.eq(flexslider.animatingTo || flexslider.currentSlide || 0).innerHeight());
      }
    }

    function scheduleSliderLayoutRefresh() {
      refreshSliderLayout();
      window.requestAnimationFrame(function() {
        refreshSliderLayout();
        updateArrowContrast();
      });
      window.setTimeout(function() {
        refreshSliderLayout();
        updateArrowContrast();
      }, 120);
      window.setTimeout(function() {
        refreshSliderLayout();
        updateArrowContrast();
      }, 450);
      window.setTimeout(function() {
        refreshSliderLayout();
        updateArrowContrast();
      }, 1000);
    }

    function enableImageSwipe() {
      if (slider.dataset.swipeReady === 'true') return;
      slider.dataset.swipeReady = 'true';

      var ignoredSelector = 'a, button, input, textarea, select, label, .flex-direction-nav, .flex-control-nav';
      var active = false;
      var pointerId = null;
      var startX = 0;
      var startY = 0;
      var lastX = 0;
      var lastY = 0;

      function shouldIgnoreSwipe(target) {
        return target && target.closest && target.closest(ignoredSelector);
      }

      function startSwipe(clientX, clientY) {
        active = true;
        startX = clientX;
        startY = clientY;
        lastX = clientX;
        lastY = clientY;
        slider.classList.add('is-dragging');
      }

      function finishSwipe(event) {
        if (!active) return;

        var dx = lastX - startX;
        var dy = lastY - startY;
        var threshold = clamp(slider.clientWidth * 0.08, 40, 120);
        var isHorizontalSwipe = Math.abs(dx) > threshold && Math.abs(dx) > (Math.abs(dy) * 1.25);

        active = false;
        pointerId = null;
        slider.classList.remove('is-dragging');

        if (!isHorizontalSwipe) return;

        if (event && event.cancelable) event.preventDefault();
        moveSlider(dx < 0 ? 'next' : 'prev');
      }

      if (window.PointerEvent) {
        slider.addEventListener('pointerdown', function(event) {
          if (shouldIgnoreSwipe(event.target)) return;
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          pointerId = event.pointerId;
          startSwipe(event.clientX, event.clientY);
          if (slider.setPointerCapture) slider.setPointerCapture(pointerId);
        });

        slider.addEventListener('pointermove', function(event) {
          if (!active || event.pointerId !== pointerId) return;
          lastX = event.clientX;
          lastY = event.clientY;
          var dx = lastX - startX;
          var dy = lastY - startY;
          if (Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy) && event.cancelable) {
            event.preventDefault();
          }
        }, { passive: false });

        slider.addEventListener('pointerup', finishSwipe, { passive: false });
        slider.addEventListener('pointercancel', function() {
          active = false;
          pointerId = null;
          slider.classList.remove('is-dragging');
        });
      } else {
        slider.addEventListener('touchstart', function(event) {
          if (event.touches.length !== 1 || shouldIgnoreSwipe(event.target)) return;
          startSwipe(event.touches[0].clientX, event.touches[0].clientY);
        }, { passive: true });

        slider.addEventListener('touchmove', function(event) {
          if (!active || event.touches.length !== 1) return;
          lastX = event.touches[0].clientX;
          lastY = event.touches[0].clientY;
          var dx = lastX - startX;
          var dy = lastY - startY;
          if (Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy) && event.cancelable) {
            event.preventDefault();
          }
        }, { passive: false });

        slider.addEventListener('touchend', finishSwipe, { passive: false });
        slider.addEventListener('touchcancel', function() {
          active = false;
          slider.classList.remove('is-dragging');
        });
      }
    }

    function startFlexslider() {
      if (slider.dataset.ready === 'true') return;

      if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.flexslider) {
        window.setTimeout(startFlexslider, 50);
        return;
      }

      slider.dataset.ready = 'true';
      window.jQuery(slider).flexslider({
        animation: 'slide',
        controlNav: true,
        directionNav: true,
        animationSpeed: 600,
        slideshow: true,
        touch: false,
        pauseOnHover: true,
        useCSS: true,
        smoothHeight: true,
        start: function() {
          enableImageSwipe();
          scheduleSliderLayoutRefresh();
        },
        after: function() {
          scheduleSliderLayoutRefresh();
        }
      });
    }

    var resizeRefresh = debounce(scheduleSliderLayoutRefresh, 150);
    window.addEventListener('resize', resizeRefresh, { passive: true });
    window.addEventListener('orientationchange', function() {
      window.setTimeout(scheduleSliderLayoutRefresh, 250);
    });

    slider.querySelectorAll('img').forEach(function(img) {
      img.addEventListener('load', scheduleSliderLayoutRefresh, { once: true });
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            startFlexslider();
            observer.disconnect();
          }
        });
      }, { rootMargin: '200px 0px' });
      observer.observe(slider);
    } else {
      startFlexslider();
    }
  }


  function initMobileDrawerStacking() {
    var drawers = document.querySelectorAll('#shopify-section-header .menu-drawer-container');
    if (!drawers.length) return;

    drawers.forEach(function(drawer) {
      if (drawer.dataset.cosmoshopStackingReady === 'true') return;
      drawer.dataset.cosmoshopStackingReady = 'true';

      var topMenu = drawer.closest('.header-top-menu');

      function syncDrawerStacking() {
        var isOpen = drawer.hasAttribute('open') || drawer.classList.contains('menu-opening');
        if (topMenu) topMenu.classList.toggle('cosmoshop-drawer-front', isOpen);
        document.body.classList.toggle('cosmoshop-header-drawer-open', isOpen);
      }

      syncDrawerStacking();
      drawer.addEventListener('toggle', syncDrawerStacking);

      if ('MutationObserver' in window) {
        var observer = new MutationObserver(syncDrawerStacking);
        observer.observe(drawer, { attributes: true, attributeFilter: ['open', 'class'] });
      }
    });
  }



  function initMobileSearchStacking() {
    var searchDetails = document.querySelectorAll('#shopify-section-header details-modal.header__search details');
    if (!searchDetails.length) return;

    function syncSearchStacking() {
      var isOpen = Array.prototype.some.call(searchDetails, function(details) {
        return details.hasAttribute('open');
      });
      document.body.classList.toggle('cosmoshop-search-open', isOpen);
    }

    searchDetails.forEach(function(details) {
      if (details.dataset.cosmoshopSearchStackingReady === 'true') return;
      details.dataset.cosmoshopSearchStackingReady = 'true';
      details.addEventListener('toggle', syncSearchStacking);

      if ('MutationObserver' in window) {
        var observer = new MutationObserver(syncSearchStacking);
        observer.observe(details, { attributes: true, attributeFilter: ['open'] });
      }
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') window.setTimeout(syncSearchStacking, 0);
    });
    document.addEventListener('click', function() {
      window.setTimeout(syncSearchStacking, 0);
    });

    syncSearchStacking();
  }

  function initSlideshows() {
    document.querySelectorAll('#tm-flexslider').forEach(initSlideshow);
  }

  ready(function() {
    initBrandMenu();
    initCollectionSort();
    initSlideshows();
    initMobileDrawerStacking();
    initMobileSearchStacking();
  });

  document.addEventListener('shopify:section:load', function() {
    initBrandMenu();
    initSlideshows();
    initMobileDrawerStacking();
    initMobileSearchStacking();
  });
})();


/* Cosmoshop: keep installment banner amounts and links in sync with selected variant */
(function() {
  'use strict';

  function parseVariantPrices(wrapper) {
    var dataNode = wrapper.querySelector('[data-cosmoshop-installment-variants]');
    if (!dataNode) return [];
    try {
      return JSON.parse(dataNode.textContent || '[]');
    } catch (error) {
      return [];
    }
  }

  function getSelectedVariantId(wrapper) {
    var section = wrapper.closest('.shopify-section') || document;
    var formInput = section.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (formInput && formInput.value) return String(formInput.value);

    var params = new URLSearchParams(window.location.search);
    if (params.get('variant')) return String(params.get('variant'));

    return null;
  }

  function formatInstallmentAmount(cents) {
    var amount = Number(cents || 0) / 400;
    return '$' + amount.toLocaleString('en-NZ', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function getSelectedQuantity(wrapper) {
    var section = wrapper.closest('.shopify-section') || document;
    var quantityInput = section.querySelector('form[action*="/cart/add"] input[name="quantity"], input[name="quantity"][form^="product-form-"]');
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
    return Math.max(1, isNaN(quantity) ? 1 : quantity);
  }

  function buildCartAddUrl(variantId, quantity) {
    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return addUrl + '?id=' + encodeURIComponent(variantId) + '&quantity=' + encodeURIComponent(quantity || 1) + '&return_to=%2Fcheckout';
  }

  function buildAjaxCartUrl(routeName, fallback) {
    var url = (window.routes && window.routes[routeName]) || fallback;
    if (url.indexOf('.js') !== -1) return url;
    return url.replace(/(\?.*)?$/, function(query) {
      return '.js' + (query || '');
    });
  }

  function updateWrapper(wrapper) {
    var variants = parseVariantPrices(wrapper);
    if (!variants.length) return;

    var selectedId = getSelectedVariantId(wrapper);
    var selected = variants.find(function(variant) {
      return String(variant.id) === String(selectedId);
    }) || variants[0];
    var quantity = getSelectedQuantity(wrapper);
    var isAvailable = selected.available !== false;

    wrapper.querySelectorAll('[data-cosmoshop-installment-amount]').forEach(function(node) {
      node.textContent = formatInstallmentAmount(selected.price);
    });

    wrapper.querySelectorAll('[data-cosmoshop-installment-checkout]').forEach(function(link) {
      if (isAvailable) {
        link.href = buildCartAddUrl(selected.id, quantity);
        link.classList.remove('is-disabled');
        link.removeAttribute('aria-disabled');
      } else {
        link.href = '#';
        link.classList.add('is-disabled');
        link.setAttribute('aria-disabled', 'true');
      }
    });
  }

  function updateAllInstallments() {
    document.querySelectorAll('[data-cosmoshop-installments]').forEach(updateWrapper);
  }

  function triggerNativeAfterpay(wrapper) {
    var native = document.querySelector('[data-cosmoshop-afterpay-native]');
    if (!native) return false;
    var clickable = native.querySelector('a[href], button, [role="button"], [tabindex]:not([tabindex="-1"])');
    if (!clickable) return false;
    clickable.click();
    return true;
  }

  function redirectToCheckout(provider) {
    var checkoutUrl = '/checkout';
    if (provider) {
      checkoutUrl += '?preferred_payment=' + encodeURIComponent(provider);
    }
    window.location.href = checkoutUrl;
  }

  function beginInstallmentCheckout(trigger) {
    if (!trigger || trigger.getAttribute('aria-disabled') === 'true') return;

    var wrapper = trigger.closest('[data-cosmoshop-installments]');
    if (!wrapper) return;

    var selectedId = getSelectedVariantId(wrapper);
    var quantity = getSelectedQuantity(wrapper);
    if (!selectedId) return;

    trigger.classList.add('is-loading');
    trigger.setAttribute('aria-busy', 'true');

    var provider = trigger.getAttribute('data-cosmoshop-payment-provider') || '';
    var providerLabel = trigger.getAttribute('data-cosmoshop-payment-label') || provider;
    var fallbackUrl = buildCartAddUrl(selectedId, quantity);

    if (!window.fetch) {
      window.location.href = fallbackUrl;
      return;
    }

    fetch(buildAjaxCartUrl('cart_add_url', '/cart/add'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: Number(selectedId),
          quantity: quantity,
          properties: {
            '_Preferred payment': providerLabel
          }
        }]
      })
    }).then(function(response) {
      if (!response.ok) throw new Error('Unable to add item to cart.');
      return response.json();
    }).then(function() {
      return fetch(buildAjaxCartUrl('cart_update_url', '/cart/update'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            'Preferred payment': providerLabel
          }
        })
      }).catch(function() {});
    }).then(function() {
      redirectToCheckout(provider);
    }).catch(function() {
      window.location.href = fallbackUrl;
    });
  }

  function initInstallmentUpdater() {
    updateAllInstallments();

    document.addEventListener('change', function(event) {
      var target = event.target;
      if (!target) return;
      if (target.name === 'id' || target.name === 'options[]' || target.name === 'quantity' || target.closest('variant-selects, variant-radios')) {
        window.setTimeout(updateAllInstallments, 0);
      }
    });

    document.addEventListener('input', function(event) {
      var target = event.target;
      if (target && target.name === 'quantity') {
        window.setTimeout(updateAllInstallments, 0);
      }
    });

    document.addEventListener('variant:change', function() {
      window.setTimeout(updateAllInstallments, 0);
    });

    document.addEventListener('click', function(event) {
      var checkoutTrigger = event.target.closest('[data-cosmoshop-installment-checkout]');
      if (checkoutTrigger) {
        event.preventDefault();
        beginInstallmentCheckout(checkoutTrigger);
        return;
      }

      if (event.target.closest('quantity-input .quantity__button')) {
        window.setTimeout(updateAllInstallments, 0);
      }

      var afterpayTrigger = event.target.closest('[data-cosmoshop-afterpay-trigger]');
      if (afterpayTrigger && triggerNativeAfterpay(afterpayTrigger.closest('[data-cosmoshop-installments]'))) {
        event.preventDefault();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInstallmentUpdater, { once: true });
  } else {
    initInstallmentUpdater();
  }

  document.addEventListener('shopify:section:load', function() {
    window.setTimeout(updateAllInstallments, 0);
  });
})();
